import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import { Skeleton } from "primereact/skeleton";
import CustomeButton from "~/components/Button";
import usersIcon from "../../../assets/images/users-icons.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";
import AdminOnly from "~/components/AdminOnly";

const EmployeesDataTable = ({
  employees,
  isDataAvailable,
  totalRecords,
  page,
  rows,
  onPageChange,
  onSortChange,
  loading,
  searchQuery,
  sortBy,
  sortOrder,
}) => {
  const navigate = useNavigate();
  const { id: entityId } = useParams();
  const skeletonRows = [...Array(5)];

  const truncateJobTitle = (title) => {
    if (!title) return "";
    return title.length > 20 ? title.slice(0, 20) + "..." : title;
  };

  return (
    <div>
      {isDataAvailable || searchQuery ? (
        <DataTable
          value={loading ? skeletonRows : employees}
          className="datatable-right-align"
          lazy
          paginator={totalRecords > 10}
          first={page * rows}
          rows={rows}
          totalRecords={totalRecords}
          onPage={onPageChange}
          onSort={onSortChange}
          sortField={sortBy}
          sortOrder={sortOrder}
          rowsPerPageOptions={[10, 20, 30]}
          emptyMessage="No results were found"
        >
          <Column
            header="Employee ID"
            className="employee-column"
            field="employee_identifier"
            body={(data) =>
              loading ? <Skeleton width="100%" /> : data.employee_identifier
            }
          />

          <Column
            header="Full Name"
            className="employee-column"
            sortable
            field="name"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <Link
                  className="request__link"
                  to={`/employee/${data?.id}/info`}
                >
                  {data.preferred_name || `${data.name} ${data.last_name}`}
                </Link>
              )
            }
          />

          <Column
            header="Work Email"
            className="employee-column"
            sortable
            field="work_email"
            body={(data) =>
              loading ? <Skeleton width="100%" /> : data.work_email
            }
          />

          <Column
            header="Job Title"
            className="employee-column"
            sortable
            field="job_title"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                truncateJobTitle(data.job_title)
              )
            }
          />

          <Column
            header="Status"
            className="employee-column"
            sortable
            field="employment_status"
            body={(data) =>
              loading ? <Skeleton width="100%" /> : data.employment_status
            }
          />

          <Column
            header="Start Date"
            className="employee-column"
            sortable
            field="start_date"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                format(data.start_date, "MMMM do, yyyy")
              )
            }
          />

          <Column
            header="End Date"
            className="employee-column"
            sortable
            field="end_date"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : data.end_date ? (
                format(data.end_date, "MMMM do, yyyy")
              ) : (
                "-"
              )
            }
          />
        </DataTable>
      ) : (
        <div className="flex flex-column justify-content-center align-items-center p-5">
          <div className="no-employees-container">
            <div className="no-employees-icon flex justify-content-center align-items-center">
              <img src={usersIcon} />
            </div>
            <div className="flex flex-column align-items-center gap-1">
              <p className="no-employees-heading m-0">
                No Employees registered yet
              </p>
              <p className="mb-0 mt-1">Let’s add your first one</p>
            </div>
            <AdminOnly>
              <CustomeButton
                label={"Add Employee"}
                variant="outlined"
                className="access-btn"
                icon="pi pi-plus"
                iconPos="right"
                onClick={() =>
                  navigate(`/entity/${entityId}/employee-registry`)
                }
              />
            </AdminOnly>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeesDataTable;
